export default __webpack_public_path__ + "img/f0f56ebdd18d60529fc78e6371af6ea2.svg";